class ApiError {
  constructor(message, data) {
    Object.assign(this, { ...data, message });
  }
}

export default ApiError;
